import "./App.css";

import Greeting from "./Component/greeting";
import StudentList from "./Component/StudentList";
import RegistrationForm from "./Component/Registretionform";
import ControlledForm from "./Component/controlled_form";


function App() {
  return (
    <div>
      {/* Uncomment components to test */}

      {/* <Greeting /> */}
      {/* <StudentList /> */}
      {/* <ControlledForm /> */}
      {/* <RegistrationForm /> */}

    </div>
  );
}

export default App;